import React, { useState } from 'react';
import "../../Styles/yellocalfcss/SendInvoice.css";
import { Button, Form, Spinner, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { simplePostCall } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';

function SendFeeInvoice() {
  const { id } = useParams(); // Get invoice ID from URL if available
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState({ type: '', text: '' });

  const handleSendClick = async () => {
    if (message.trim() === '') {
      alert('Please enter an additional message.');
      return;
    }

    setIsLoading(true);
    setApiResponse({ type: '', text: '' });

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id") || 1005),
      api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
      language: "en",
      user_id: Number(localStorage.getItem("user_id") || 14857),
      id: id || "2994", // Uses URL param or fallback
      parent_message: message 
    };

    try {
      const response = await simplePostCall(
        ApiConfig.SendInvoice, // Ensure this endpoint exists in your ApiConfig
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        setApiResponse({ type: 'success', text: 'Invoice message sent successfully!' });
        setMessage(''); // Clear textarea on success
      } else {
        setApiResponse({ type: 'danger', text: response?.message || "Failed to send invoice." });
      }
    } catch (error) {
      console.error("Error sending invoice:", error);
      setApiResponse({ type: 'danger', text: "An error occurred while submitting." });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="SendInvoice-wrapper">
      <div className="SendInvoice-top-bar">
        <div className="SendInvoice-page-title">Send Fee Invoice balance</div>
        <div className="SendInvoice-sms-balance">
          Available SMS Balance is : <span className="SendInvoice-balance-box">1227.00</span>
        </div>
      </div>

      {apiResponse.text && (
        <Alert variant={apiResponse.type} className="mt-3 mx-4" onClose={() => setApiResponse({type:'', text:''})} dismissible>
          {apiResponse.text}
        </Alert>
      )}

      <div className="SendInvoice-content-box">
        <div className="SendInvoice-left-box">
          <p>Greetings Amit,</p>
          <p>Your outstanding balance for Ashutose, admission number : fsdf35346 is $ 3700. Due date is 2024-06-10</p>
        </div>
        <div className="SendInvoice-right-box">
          <Form>
            <Form.Group controlId="additionalMessage">
              <Form.Label className="SendInvoice-label">
                Additional Message <span className="SendInvoice-required">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Type your message here..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                disabled={isLoading}
              />
            </Form.Group>
            <Button 
              variant="primary" 
              className="SendInvoice-send-btn mt-3" 
              onClick={handleSendClick}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  <span className="ms-2">Sending...</span>
                </>
              ) : 'Send'}
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default SendFeeInvoice;